import Vue from "vue";
import Vuex from "vuex";
//import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appTitle: 'tendle',
    /** Last 8 text colors used in the editor color picker (hex strings, most recent first). */
    textColorHistory: [],
  },
  mutations: {
    /** Add a color to text color history. Keeps at most 8, most recent first, no duplicates. */
    addTextColor(state, color) {
      if (!color || typeof color !== 'string') return;
      const hex = color.trim().toLowerCase();
      if (!/^#[0-9a-f]{6}$/.test(hex) && !/^#[0-9a-f]{8}$/.test(hex)) return;
      const rest = state.textColorHistory.filter((c) => c !== hex);
      state.textColorHistory = [hex, ...rest].slice(0, 8);
    },
  },
  actions: {
    
  
  }

});
